import { useEffect } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'

import { api } from '../lib/api'
import { chatTarget, FREE_LANES_HOME } from '../lib/chatNavigation'

type FirstFreeLaneResponse = {
  status: 'found' | 'none'
  chat_id: string | null
  lane_id: string | null
  display_name: string | null
  url: string
}

export default function FirstFreeLanePage() {
  const navigate = useNavigate()
  const location = useLocation()
  const { data, error, isLoading } = useQuery({
    queryKey: ['first-free-lane', location.key],
    queryFn: () => api<FirstFreeLaneResponse>('/api/chats/first-free-lane', { cache: 'no-store' }),
    retry: 1,
    staleTime: 0,
    gcTime: 0,
  })

  useEffect(() => {
    if (!data) return
    navigate(data.chat_id ? chatTarget(data.chat_id) : FREE_LANES_HOME, { replace: true })
  }, [data, navigate])

  if (error) {
    return (
      <div className="grid h-full place-items-center px-6">
        <div className="max-w-sm text-center">
          <div className="mb-2 text-sm font-semibold">Could not check free lanes</div>
          <p className="mb-4 text-xs text-stone-500">
            The live resolver failed, so no lane was opened.
          </p>
          <Link
            to={FREE_LANES_HOME}
            replace
            className="inline-flex items-center justify-center rounded-lg bg-stone-900 px-3 py-2 text-xs font-semibold text-white dark:bg-stone-100 dark:text-stone-900"
          >
            Show Free lanes
          </Link>
        </div>
      </div>
    )
  }

  return (
    <div className="grid h-full place-items-center px-6 text-sm text-stone-500">
      {isLoading ? 'Finding the first free lane...' : 'Opening free lane...'}
    </div>
  )
}
